import { Box, Grid, Typography } from "@material-ui/core";
import {
  BLUE_PRIMARY,
  cities,
  WHITE,
  consumptionRecordsPageSize,
  GREEN_PRIMRY,
  ERROR_COLOR,
  ORANGE_COLOR,
  BLUE_COLOR,
} from "../utils/const";
import ProjectImage from "../assets/img/project.jpg";
import { Bar, Line } from "react-chartjs-2";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { convertNumbers } from "../utils/ConvertNumbers";
import ProjectByCityChart from "../components/projectsByCitiesChart";
import InfoIcon from "@material-ui/icons/Info";
import useCustomState from "../hooks/State";
import { useMountAPI } from "../hooks/APICall";
import Call from "../service/API";
import { useEffect } from "react";
import Loading from "../components/loading";
import Paginator from "../components/paginator"; // for pagination
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import { Split } from "../utils/Split";
import ChartFilters from "../components/chartFilters";
import {
  createDates,
  getJsonDate,
  isBefore,
  jalaliToUtc,
} from "../utils/TimeUtils";
import moment from "jalali-moment";
import { useSelector } from "react-redux";
// import Paginator from "../components/paginator";

const ConsumptionReports = (props) => {
  const categories = useSelector((state) => state.categories);

  const isLoading = useCustomState(true);
  const labels = useCustomState([]);
  const values = useCustomState([]);
  const datasets = useCustomState([]);

  const consumptionRecords = useCustomState([]);
  const consumptionRecordsIsLoading = useCustomState(true);
  const allItems = useCustomState(0); // for pagination
  const selectedPage = useCustomState(1); // for pagination

  const category = useCustomState(
    categories.length > 0 ? categories[categories.length - 1] : null
  );

  const categoryChanged = (newValue) => {
    if (category.value === null) {
      category.handleChange(newValue);
    } else {
      if (newValue.id !== category.value.id) {
        category.handleChange(newValue);
      }
    }
  };

  /*
  begin: for filters
  */
  const numBefore = 13;
  const numAfter = 1;

  const tenBefore = moment().add(-numBefore, "day").locale("utc");
  const oneAfter = moment().add(numAfter, "day").locale("utc");

  const start = useCustomState(getJsonDate(tenBefore));
  const end = useCustomState(getJsonDate(oneAfter));

  const startError = useCustomState({ error: false, text: "" });

  const user = useCustomState({ name: "همه", id: null });
  const project = useCustomState({ name: "همه", id: null });
  const type = useCustomState({ name: "همه", id: null });
  const counter = useCustomState({ name: "همه", id: null });

  const startChanged = (newDate) => {
    startError.handleChange({ error: false, text: "" });
    start.handleChange(newDate);
  };
  const endChanged = (newDate) => {
    startError.handleChange({ error: false, text: "" });
    end.handleChange(newDate);
  };

  const chartType = useCustomState("bar");

  const chartTypeChanged = (newValue) => {
    if (newValue !== chartType.value) {
      chartType.handleChange(newValue);
    }
  };

  const userChanged = (newValue) => {
    if (newValue.id !== user.value.id) {
      user.handleChange(newValue);
    }
  };

  const projectChanged = (newValue) => {
    if (newValue.id !== project.value.id) {
      project.handleChange(newValue);
    }
  };

  const typeChanged = (newValue) => {
    if (newValue.id !== type.value.id) {
      type.handleChange(newValue);
    }
  };

  const counterChanged = (newValue) => {
    if (newValue.id !== counter.value.id) {
      counter.handleChange(newValue);
    }
  };
  /*
  end: for filters
  */

  const history = useHistory();

  const jStart = getJsonDate(moment().add(-numBefore, "day").locale("utc"));
  const jEnd = getJsonDate(moment().add(numAfter, "day").locale("utc"));
  const dates = createDates(jStart, jEnd);

  const consumptionUtils = {
    page: 1,
    count: 1000,
    isLoading: isLoading,
    projectId: project.value.id,
    userId: user.value.id,
    counterId: counter.value.id,
    counterType: type.value.id,
    categoryId: category.value === null ? null : category.value.id,
    startTime: moment()
      .add(-numBefore, "day")
      .locale("utc")
      .format("YYYY-MM-DDT00:00:00Z"),
    endTime: moment()
      .add(numAfter, "day")
      .locale("utc")
      .format("YYYY-MM-DDT00:00:00Z"),
    labels: labels,
    values: values,
    dates: dates,
  };

  const consumptionRecordsUtils = {
    page: selectedPage.value, // for pagination
    count: consumptionRecordsPageSize, // for pagination
    isLoading: consumptionRecordsIsLoading,
    consumptionData: consumptionRecords,
    projectId: project.value.id,
    userId: user.value.id,
    counterId: counter.value.id,
    counterType: type.value.id,
    startTime: moment()
      .add(-numBefore, "day")
      .locale("utc")
      .format("YYYY-MM-DDT00:00:00Z"),
    endTime: moment()
      .add(numAfter, "day")
      .locale("utc")
      .format("YYYY-MM-DDT00:00:00Z"),
    allItems: allItems, // for pagination
    history: history,
  };

  const totalStatisticsIsLoading = useCustomState(true);
  const totalStatistics = useCustomState({});

  const totalStatisticsUtils = {
    isLoading: totalStatisticsIsLoading,
    totalStatistics: totalStatistics,
    history: history,
  };

  useMountAPI(fetchConsumption, consumptionUtils);
  useMountAPI(fetchConsumptionsRecords, consumptionRecordsUtils);
  useMountAPI(fetchStatistics, totalStatisticsUtils);

  useEffect(() => {
    if (!isLoading.value) {
      let color = GREEN_PRIMRY;
      if (category.value.name.includes("آب")) {
        color = BLUE_PRIMARY;
      } else if (category.value.name.includes("برق")) {
        color = ERROR_COLOR;
      } else if (category.value.name.includes("گاز")) {
        color = ORANGE_COLOR;
      } else {
        color = GREEN_PRIMRY;
      }

      const d = [
        {
          label: "مقدار مصرف " + category.value.name,
          data: values.value.map((value, index) => value),
          backgroundColor: color,
          borderColor: color,
          fill: false,
          barThickness: "flex",
          maxBarThickness: 48,
          minBarLength: 18,
        },
      ];
      datasets.handleChange(d);
    }
  }, [isLoading.value]);

  const data = {
    labels: labels.value,
    datasets: datasets.value,
  };

  const options = {
    legend: { labels: { fontFamily: "Vazir" }, rtl: false },
    scales: {
      yAxes: [
        {
          ticks: {
            // fontSize: 40
            fontFamily: "Vazir",
            beginAtZero: true,
            userCallback: (label, index, labels) => {
              return Split(convertNumbers(label));
            },
          },
        },
      ],
      xAxes: [
        {
          ticks: {
            fontFamily: "Vazir",
            userCallback: (label, index, labels) => {
              return convertNumbers(label);
            },
          },
          offset: true,
        },
      ],
    },
    tooltips: {
      bodyFontFamily: "Vazir",
      // mode: 'label',
      callbacks: {
        title: (tooltipItem, data) => {
          const indice = tooltipItem.index;
          return convertNumbers(data.labels[indice]);
        },
        label: (tooltipItem, data) => {
          const indice = tooltipItem.index;
          return (
            "مقدار مصرف" +
            ": " +
            convertNumbers(
              data.datasets[tooltipItem.datasetIndex].data[indice]
            ) +
            ""
          );
        },
      },
    },
  };

  const applyFilters = (data) => {
    if (!isBefore(start.value, end.value)) {
      startError.handleChange({
        error: true,
        text: "تاریخ شروع انتخاب شده باید قبل از تاریخ پایان باشد.",
      });
      return;
    }
    isLoading.handleChange(true);
    consumptionRecordsIsLoading.handleChange(true);
    chartTypeChanged(data.chartType);
    categoryChanged(data.category);
    userChanged(data.user);
    projectChanged(data.project);
    typeChanged(data.type);
    counterChanged(data.counter);
    const fromDate = jalaliToUtc(start.value);
    const toDate = jalaliToUtc(end.value, false);
    const consumptionUtils = {
      page: 1,
      count: 1000,
      isLoading: isLoading,
      projectId: data.project.id,
      userId: data.user.id,
      counterId: data.counter.id,
      counterType: data.type.id,
      categoryId: data.category.id,
      startTime: fromDate.format("YYYY-MM-DDT00:00:00Z"),
      endTime: toDate.format("YYYY-MM-DDT00:00:00Z"),
      labels: labels,
      values: values,
      dates: createDates(start.value, end.value),
    };
    consumptionRecordsUtils.page = selectedPage.value; // for pagination
    consumptionRecordsUtils.count = consumptionRecordsPageSize; // for pagination
    consumptionRecordsUtils.isLoading = consumptionRecordsIsLoading;
    consumptionRecordsUtils.consumptionData = consumptionRecords;
    consumptionRecordsUtils.projectId = data.project.id;
    consumptionRecordsUtils.userId = data.user.id;
    consumptionRecordsUtils.counterId = data.counter.id;
    consumptionRecordsUtils.counterType = data.type.id;
    consumptionRecordsUtils.startTime = fromDate.format("YYYY-MM-DDT00:00:00Z");
    consumptionRecordsUtils.endTime = toDate.format("YYYY-MM-DDT00:00:00Z");
    consumptionRecordsUtils.allItems = allItems; // for pagination
    consumptionRecordsUtils.history = history;
    fetchConsumption(consumptionUtils);
    fetchConsumptionsRecords(consumptionRecordsUtils);
  };

  // console.log(totalStatistics.value);

  const renderChart = () => {
    if (chartType.value === "line") {
      return <Line options={options} data={data} />;
    } else {
      return <Bar options={options} data={data} />;
    }
  };

  // for pagination
  const selectedPageChanged = (newPage) => {
    if (newPage !== selectedPage.value) {
      selectedPage.handleChange(newPage);
      const fromDate = jalaliToUtc(start.value);
      const toDate = jalaliToUtc(end.value, false);
      consumptionRecordsUtils.page = newPage;
      consumptionRecordsUtils.count = consumptionRecordsPageSize; // for pagination
      consumptionRecordsUtils.isLoading = consumptionRecordsIsLoading;
      consumptionRecordsUtils.consumptionData = consumptionRecords;
      consumptionRecordsUtils.projectId = project.value.id;
      consumptionRecordsUtils.userId = user.value.id;
      consumptionRecordsUtils.counterId = counter.value.id;
      consumptionRecordsUtils.counterType = type.value.id;
      consumptionRecordsUtils.startTime = fromDate.format(
        "YYYY-MM-DDT00:00:00Z"
      );
      consumptionRecordsUtils.endTime = toDate.format("YYYY-MM-DDT00:00:00Z");
      consumptionRecordsUtils.allItems = allItems; // for pagination
      consumptionRecordsUtils.history = history;
      consumptionRecordsIsLoading.handleChange(true);
      fetchConsumptionsRecords(consumptionRecordsUtils);
    }
  };

  const renderPaginator = () => {
    {
      /* 
            begin: for pagination
          */
    }
    return (
      <Grid item sx={12} sm={12} md={12} lg={12}>
        <Grid container>
          <Paginator
            selectedPage={selectedPage.value}
            items={allItems.value}
            pageSize={consumptionRecordsPageSize}
            selectedPageChanged={selectedPageChanged}
          />
        </Grid>
      </Grid>
    );
    {
      /* end: for pagination */
    }
  };

  const renderConsumptionStatisticsTable = () => {
    if (totalStatisticsIsLoading.value) {
      return (
        <div style={{ position: "relative", width: "100%", height: "320px" }}>
          <Loading />
        </div>
      );
    } else {
      return (
        <TableContainer
          component={Paper}
          style={{
            width: "400px",
            maxWidth: "400px",
            marginRight: "auto",
            marginLeft: "auto",
          }}
        >
          <Table sx={{ maxWidth: 700 }} aria-label="customized table">
            <TableBody>
              <TableRow>
                <TableCell>تعداد کل رکوردهای مصرف</TableCell>
                <TableCell>
                  {convertNumbers(Split(totalStatistics.value.allRecords))}
                </TableCell>
              </TableRow>
              {totalStatistics.value.categoryInfo.map((category) => {
                return (
                  <TableRow>
                    <TableCell>
                      {"تعداد رکوردهای مصرف " + category.name}
                    </TableCell>
                    <TableCell>
                      {convertNumbers(Split(category.records))}
                    </TableCell>
                  </TableRow>
                );
              })}
              {totalStatistics.value.categoryInfo.map((category) => {
                const consumptions = category.consumptions
                  ? category.consumptions
                  : 0;

                // console.log(consumptions);
                return (
                  <TableRow>
                    <TableCell>{"میزان مصرف " + category.name}</TableCell>
                    <TableCell>{convertNumbers(consumptions)}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      );
    }
  };

  const renderConsumptionStatistics = () => {
    return (
      <>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            marginTop: "48px",
            paddingBottom: "16px",
            marginBottom: "16px",
            borderBottom: "1px solid #333333",
          }}
        >
          <Box
            textAlign={"left"}
            style={{
              maxWidth: "400px",
              width: "400px",
              marginRight: "auto",
              marginLeft: "auto",
              marginBottom: "16px",
            }}
          >
            <Typography style={{ fontWeight: "bold" }}>آمار کلی</Typography>
          </Box>
          {renderConsumptionStatisticsTable()}
        </Grid>
      </>
    );
  };

  const renderChartContent = () => {
    if (!isLoading.value) {
      return (
        <Grid item xs={12} sm={12} md={12} lg={12}>
          {renderChart()}
        </Grid>
      );
    } else {
      return (
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{ height: "260px", position: "relative" }}
        >
          <Loading />
        </Grid>
      );
    }
  };

  const renderConsumptionChart = () => {
    return (
      <>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{ marginBottom: "16px" }}
        >
          <Typography style={{ fontWeight: "bold" }}>
            آمار میزان مصرف
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            borderBottom: "1px solid #333333",
          }}
        >
          <Grid container>
            <ChartFilters
              start={start}
              startError={startError}
              startChanged={startChanged}
              end={end}
              endChanged={endChanged}
              renderChartType={true}
              chartTypeChanged={chartTypeChanged}
              renderCategories={true}
              categories={categories}
              categoryChanged={categoryChanged}
              applyFilters={applyFilters}
              renderUsers={true}
              renderProjects={true}
              renderTypes={true}
              renderCounters={true}
            />
            {renderChartContent()}
          </Grid>
        </Grid>
      </>
    );
  };

  const renderConsumptionDetailsTable = () => {
    if (consumptionRecordsIsLoading.value) {
      return (
        <div style={{ position: "relative", width: "100%", height: "260px" }}>
          <Loading />
        </div>
      );
    } else {
      return (
        <TableContainer
          component={Paper}
          style={{
            marginRight: "auto",
            marginLeft: "auto",
          }}
        >
          <Table sx={{ maxWidth: 700 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <TableCell align={"center"}>#</TableCell>
                <TableCell align={"center"}>از تاریخ</TableCell>
                <TableCell align={"center"}>تا تاریخ</TableCell>
                <TableCell align={"center"}>مقدار</TableCell>
                <TableCell align={"center"}>پروژه</TableCell>
                <TableCell align={"center"}>دسته</TableCell>
                <TableCell align={"center"}>نوع کنتور</TableCell>
                <TableCell align={"center"}>شماره سریال</TableCell>
                <TableCell align={"center"}>کاربر</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {consumptionRecords.value.map((c, idx) => {
                const fromDate = moment(c.fromDate)
                  .locale("fa")
                  .format("YYYY/MM/DD,HH:mm:ss");
                const toDate = moment(c.toDate)
                  .locale("fa")
                  .format("YYYY/MM/DD,HH:mm:ss");
                const categoryStyle = {
                  color: "#fff",
                  backgroundColor: "green",
                  fontSize: "12px",
                  borderRadius: "4px",
                  paddingRight: "6px",
                  paddingLeft: "6px",
                  marginRight: "8px",
                };
                if (c.category.includes("آب")) {
                  categoryStyle.backgroundColor = BLUE_COLOR;
                } else if (c.category.includes("برق")) {
                  categoryStyle.backgroundColor = ERROR_COLOR;
                } else {
                  categoryStyle.backgroundColor = ORANGE_COLOR;
                }
                return (
                  <TableRow>
                    <TableCell align={"center"}>
                      {convertNumbers(
                        (selectedPage.value - 1) * consumptionRecordsPageSize +
                          idx +
                          1
                      )}
                    </TableCell>
                    <TableCell align={"center"}>
                      <span>{convertNumbers(fromDate.split(",")[0])}</span>
                      <br />
                      <span>{convertNumbers(fromDate.split(",")[1])}</span>
                    </TableCell>
                    <TableCell align={"center"}>
                      <span>{convertNumbers(toDate.split(",")[0])}</span>
                      <br />
                      <span>{convertNumbers(toDate.split(",")[1])}</span>
                    </TableCell>
                    <TableCell align={"center"}>
                      {convertNumbers(c.value)}
                    </TableCell>
                    <TableCell align={"center"}>
                      {convertNumbers(c.project)}
                    </TableCell>
                    <TableCell align={"center"}>
                      <span style={categoryStyle}>
                        {convertNumbers(c.category)}
                      </span>
                    </TableCell>
                    <TableCell align={"center"}>
                      {convertNumbers(c.type)}
                    </TableCell>
                    <TableCell align={"center"}>
                      {convertNumbers(c.serial)}
                    </TableCell>
                    <TableCell align={"center"}>{c.user}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      );
    }
  };

  const renderConsumptionDetails = () => {
    return (
      <>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            marginTop: "24px",
            paddingBottom: "16px",
            marginBottom: "16px",
            borderBottom: "1px solid #333333",
          }}
        >
          <Box
            textAlign={"left"}
            style={{
              marginRight: "auto",
              marginLeft: "auto",
              marginBottom: "16px",
            }}
          >
            <Typography style={{ fontWeight: "bold" }}>
              جزئیات رکوردهای مصرف
            </Typography>
          </Box>
          {renderConsumptionDetailsTable()}
          {renderPaginator()}
        </Grid>
      </>
    );
  };

  return (
    <Grid
      container
      style={{
        marginTop: "64px",
        paddingTop: "16px",
        paddingBottom: "16px",
        paddingRight: "8px",
        paddingLeft: "8px",
      }}
    >
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        style={{
          backgroundColor: WHITE,
          paddingRight: "16px",
          paddingLeft: "16px",
          paddingTop: "24px",
          paddingBottom: "24px",
          borderRadius: "8px",
          position: "relative",
        }}
      >
        <Box
          style={{
            maxWidth: "250px",
            marginRight: "auto",
            marginLeft: "auto",
            marginTop: "-60px",
            paddingRight: "36px",
            paddingLeft: "36px",
            paddingTop: "24px",
            paddingBottom: "24px",
            borderRadius: "12px",
            backgroundColor: GREEN_PRIMRY,
            color: WHITE,
            cursor: "pointer",
          }}
          textAlign={"center"}
        >
          <Typography style={{ fontWeight: "bold" }}>
            گزارش میزان مصرف
          </Typography>
        </Box>
        <Grid container>
          {renderConsumptionStatistics()}
          {renderConsumptionChart()}
          {renderConsumptionDetails()}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ConsumptionReports;

const renderNoData = (labels, values, dates) => {
  labels.handleChange(dates);
  const V = [];
  dates.map((d, idx) => {
    V.push(0);
  });
  values.handleChange(V);
};

const prepareChartData = (consumptions, labels, values, expectedDates) => {
  if (Array.isArray(consumptions)) {
    renderNoData(labels, values, expectedDates);
    return;
  } else {
    const dates = Object.keys(consumptions);
    const jDates = [];
    const jConsumptions = {};
    dates.map((d, idx) => {
      const jDate = moment(d).locale("fa").format("YYYY/MM/DD");
      jDates.push(jDate);
      jConsumptions[jDate] = consumptions[d];
    });
    const V = [];
    expectedDates.map((ed, idx) => {
      if (jDates.includes(ed)) {
        V.push(jConsumptions[ed]);
      } else {
        V.push(0);
      }
    });
    labels.handleChange(expectedDates);
    values.handleChange(V);
  }
};

const fetchConsumption = (utils) => {
  const page = utils.page;
  const count = utils.count;
  const isLoading = utils.isLoading;
  const projectId = utils.projectId;
  const userId = utils.userId;
  const counterId = utils.counterId;
  const counterType = utils.counterType;
  const categoryId = utils.categoryId;
  const startTime = utils.startTime;
  const endTime = utils.endTime;
  const labels = utils.labels;
  const values = utils.values;
  const dates = utils.dates;

  if (!categoryId) {
    renderNoData(labels, values, dates);
    isLoading.handleChange(false);
    return;
  } else {
    const data = {
      page: page,
      count: count,
      project_id: projectId,
      user_id: userId,
      water_meters: counterId,
      type_id: counterType,
      tag_id: categoryId,
      start_time: startTime,
      end_time: endTime,
    };

    // console.log(data);

    Call("POST", "watermeters/admin/getAll/consumption/date", data)
      .then((response) => {
        // console.log("get all consumption: ", response);
        if (response.data.code == 200) {
          const consumptions = response.data.data;
          prepareChartData(consumptions, labels, values, dates);
        }
        isLoading.handleChange(false);
      })
      .catch((error) => {
        if (error.response) {
          const data = error.response.data;
          // console.log(data);
        }
        isLoading.handleChange(false);
      });
  }
};

const processConsumptionRecords = (records) => {
  const results = [];

  records.map((c, idx) => {
    const fromDate = c.from_previous_record;
    const toDate = c.to_current_record;
    const data = {
      fromDate: fromDate.length > 0 ? c.from_previous_record : c.create_time,
      toDate: toDate.length > 0 ? c.to_current_record : c.create_time,
      value: c.value,
      project: c.project_info.water_meter_project_name,
      category: c.tag_info.water_meter_tag_name,
      type: c.type_info.water_meter_type_name,
      serial: c.water_meters_info.water_meter_serial,
      user: c.user_info.user_name + " " + c.user_info.user_lastname,
    };
    results.push(data);
  });
  return results;
};

const fetchConsumptionsRecords = (utils) => {
  const page = utils.page;
  const count = utils.count;
  const isLoading = utils.isLoading;
  const consumptionData = utils.consumptionData;
  const projectId = utils.projectId;
  const userId = utils.userId;
  const counterId = utils.counterId;
  const counterType = utils.counterType;
  const startTime = utils.startTime;
  const endTime = utils.endTime;
  const allItems = utils.allItems; // for pagination
  const history = utils.history;

  const data = {
    page: page,
    count: count,
    water_meter_project: projectId,
    water_meter_user: userId,
    water_meters: counterId,
    water_meter_type: counterType,
    start_time: startTime,
    end_time: endTime,
  };

  // console.log(data);

  Call("POST", "watermeters/admin/getAll/consumption", data)
    .then((response) => {
      // console.log("get all consumption: ", response);
      if (response.data.code == 200) {
        const consumptions = response.data.data;
        /* begin: for pagination */
        if (consumptions && consumptions.length !== 0) {
          allItems.handleChange(consumptions[0]["all_consumptions"]);
        }
        /* end: for pagination */
        consumptionData.handleChange(processConsumptionRecords(consumptions));
      }
      isLoading.handleChange(false);
    })
    .catch((error) => {
      if (error.response) {
        const data = error.response.data;
        // console.log(data);
      }
      isLoading.handleChange(false);
    });
};

const processStatistics = (statistics) => {
  const keys = Object.keys(statistics);

  const processedStatistics = {};
  const catInfo = [];
  keys.map((key) => {
    if (key === "all_consumptions") {
      processedStatistics.allRecords = statistics[key];
    } else {
      const data = {
        name: key,
        records: statistics[key].tag_count,
        consumptions: statistics[key].sum_of_all_tag_consumption,
      };
      catInfo.push(data);
    }
  });
  processedStatistics.categoryInfo = catInfo;
  return processedStatistics;
};

const fetchStatistics = (utils) => {
  const isLoading = utils.isLoading;
  const totalStatistics = utils.totalStatistics;
  const history = utils.history;

  Call("POST", "watermeters/admin/consumption/total/statistics", null)
    .then((response) => {
      // console.log("total statistics: ", response);
      if (response.data.code === 200) {
        totalStatistics.handleChange(processStatistics(response.data.data));
      }
      isLoading.handleChange(false);
    })
    .catch((error) => {
      // console.log(error);
      if (error.response) {
        const data = error.response.data;
        // console.log(data);
        if (data.code === 403) {
          history.push("/admin/login");
        }
      }
      isLoading.handleChange(false);
    });
};
